import Vue from 'vue'
import { Formatter } from '@/filters/formatter'
Vue.filter(
    'decimal',
    (value, numberFormatOptions) => Formatter.number(value, true, numberFormatOptions))
